var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{attrs:{"id":"iframe"}},[_c('p',[_vm._v("Link to sheet: "),_c('a',{attrs:{"href":_vm.url,"target":"_new"}},[_vm._v("link")])])])}
var staticRenderFns = []

export { render, staticRenderFns }